import { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import configs from "../../Constants";
import { useMediaQuery } from "@mui/material";
import { toast } from "react-toastify";

export default function EditableField({
  label,
  value,
  type = "text",
  fieldKey,
  userInfo,
  setUserInfo,
  isEditable = true,
  width = "250px",
  options
}) {
  const [editMode, setEditMode] = useState(false);
  const [fieldValue, setFieldValue] = useState(value);
  const [loading, setLoading] = useState(false);
  const [mediaOpen, setMediaOpen] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const isMobile = useMediaQuery("(max-width:768px)");

  const baseURL = configs.baseURL;
  const cmsUrl = configs.cmsUrl;
  let userToken = localStorage.getItem("token") || "";
  let staticURL = configs.staticSer;

  const handleSave = async () => {
    if (!userInfo) {
      console.error("User info is undefined");
      return;
    }

    setLoading(true);

    try {
      let updateField = {};
      if (fieldKey === "latitude" || fieldKey === "longitude") {
        const updatedCoordinates = [...userInfo.location.coordinates];

        if (fieldKey === "latitude") {
          updatedCoordinates[1] = Number(fieldValue);
        } else {
          updatedCoordinates[0] = Number(fieldValue);
        }

        updateField = {
          location: {
            ...userInfo.location,
            coordinates: updatedCoordinates,
          }
        };
        setUserInfo({
          ...userInfo, location: {
            ...userInfo.location,
            coordinates: updatedCoordinates,
          }
        });
      } else {
        updateField = { [fieldKey]: fieldValue };
      }

      //setUserInfo(updatedUserInfo);

      //   await axios.put(
      //     `${baseURL}/api/settings/${userInfo.id}`,
      //     updatedUserInfo
      //   );
      // } else {
      // const updatedUserInfo = {
      //   ...userInfo,
      //   [fieldKey]: fieldValue,
      // };



      await axios.patch(
        `${baseURL}/api/settings/${userInfo.id}`,
        updateField
      );


      toast.success(`Settings updated successfully`);
      setEditMode(false);
    } catch (error) {
      console.error("Error updating field:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSaveForImg = async (newValue = fieldValue) => {
    if (!userInfo) {
      console.error("User info is undefined");
      return;
    }

    setLoading(true);

    try {
      setUserInfo((prev) => ({
        ...prev,
        [fieldKey]: newValue,
      }));

      await axios.patch(`${baseURL}/api/settings/${userInfo.id}`, {
        [fieldKey]: newValue,
      });

      console.log("Field updated successfully!");
      setEditMode(false);
    } catch (error) {
      console.error("Error updating field:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFieldValue(value);
    setEditMode(false);
  };

  const openMediaDialog = async () => {
    setMediaOpen(true);
    setMediaLoading(true);
    try {
      const res = await axios.get(`${cmsUrl}/api/user/media`, {
        headers: { Authorization: `Bearer ${userToken}` },
      });
      if (res.data && res.data.mediaData) {
        // Filter out only the files that contain .img, .jpg, or .png
        const extractedImages = res.data.mediaData
          .filter((item) => {
            const fileName = item.original_file_name.toLowerCase();
            return (
              fileName.includes(".img") ||
              fileName.includes(".jpg") ||
              fileName.includes(".jpeg") ||
              fileName.includes(".png")
            );
          })
          .map((item) => item.original_file_name);

        console.log(extractedImages);

        setMediaList(extractedImages);
      }
    } catch (err) {
      console.error("Error fetching media:", err);
    } finally {
      setMediaLoading(false);
    }
  };

  //console.log("media", mediaList);

  const selectImage = (img) => {
    const fullUrl = staticURL.indexOf('reports') == -1 ? `${staticURL}/uploads/${img}` : `${staticURL}/users-media/${userInfo.userId}/${img}`;
    setFieldValue(fullUrl);
    setMediaOpen(false);
    handleSaveForImg(fullUrl);
  };

  const handleChange = async (val, key) => {
    console.log(key);
    console.log(val);
    try {
      let updateField = {};
      if (key == "locale") {
        updateField = { 'locale': Object.keys(val)[0] };
        localStorage.setItem("locale", Object.keys(val)[0]);
        setUserInfo({ ...userInfo, locale: Object.keys(val)[0] });
      } else if (key == 'timezone') {
        updateField = { 'timezone': val.label };
        setUserInfo({ ...userInfo, timezone: val.label });
      } else {
        updateField = { [key]: val.value };
        setUserInfo({ ...userInfo, [key]: val.value });
      }

      await axios.patch(`${baseURL}/api/settings/${userInfo.id}`, updateField, { headers: { Authorization: `Bearer ${userToken}` } });
      toast.success(`Settings updated successfully`);
    }
    catch (err) {
      console.error("Error fetching media:", err);
    } finally {
      setMediaLoading(false);
    }
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <label style={{ width: "40%", color: "#726e6e" }}>{label}:</label>
        {editMode && fieldKey !== "logo" && (
          <TextField
            size="small"
            type={type}
            value={fieldValue}
            onChange={(e) => setFieldValue(e.target.value)}
            disabled={loading}
            style={{ width: isMobile ? "40%" : "20%" }}
          />
        )}

        {!editMode && type === "color" &&
          <div
            style={{
              width: "40px",
              height: "25px",
              backgroundColor: fieldValue || "#000000",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          ></div>
        }

        {fieldKey === "logoImg" &&
          <img
            src={fieldValue}
            alt="Logo"
            style={{
              width: "60px",
              height: "auto",
              objectFit: "contain",
              borderRadius: "4px",
            }}
          />
        }

        {type == "select" && (
          <Autocomplete
            size="small"
            options={options}
            getOptionLabel={(option) => option[Object.keys(option)[0]] || ""}
            onChange={(event, newValue) => handleChange(newValue, fieldKey)}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={"Select"}
                label={value}
                style={{
                  height: "50px",
                  width: "200px",
                  maxWidth: "200px",
                  color: "#000"
                }}
              />
            )}
          />
        )}

        {fieldKey !== "logoImg" &&
          type != "color" &&
          !editMode &&
          type != "select" && (
            <span style={{ width: isMobile ? "50%" : "20%", height: "25px", overflow: "hidden" }}>
              {fieldValue || "N/A"}
            </span>
          )}

        <div>
          {isEditable && type != "select" ? (
            editMode && fieldKey !== "logoImg" ? (
              <>
                <IconButton onClick={handleSave} disabled={loading}>
                  <CheckIcon color="success" />
                </IconButton>
                <IconButton onClick={handleCancel} disabled={loading}>
                  <CloseIcon color="error" />
                </IconButton>
              </>
            ) : (
              <IconButton
                onClick={() => {
                  if (fieldKey === "logoImg") {
                    openMediaDialog();
                  } else {
                    setEditMode(true);
                  }
                }}
              >
                <EditIcon />
              </IconButton>
            )
          ) : null}
        </div>
      </div>

      {/* Media Picker Dialog */}
      <Dialog
        open={mediaOpen}
        onClose={() => setMediaOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Select Logo</DialogTitle>
        <DialogContent>
          {mediaLoading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <CircularProgress />
            </div>
          ) : (
            <Grid container spacing={2}>
              {mediaList.map((item, index) => (
                <Grid item xs={3} key={index}>
                  <img
                    src={staticURL.indexOf('reports') == -1 ? `${staticURL}/uploads/${item}` : `${staticURL}/users-media/${userInfo.userId}/${item}`}
                    alt={`Media ${index}`}
                    onClick={() => selectImage(item)}
                    style={{
                      width: "100%",
                      height: "100px",
                      objectFit: "cover",
                      cursor: "pointer",
                      borderRadius: "6px",
                      border:
                        item.url === fieldValue
                          ? "3px solid #4caf50"
                          : "1px solid #ccc",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
